import axios from 'axios';

const API_URL = 'https://dailyreportsapi.winggs.in/api/auth';

// const API_URL='http://localhost:5000/api/auth'; // Use this for local development

// Set up axios interceptor for authentication
axios.interceptors.request.use(
  (config) => {
    // Add credentials to all requests
    config.withCredentials = true;
    
    const token = localStorage.getItem('token');
    if (token) {
      // Make sure headers object exists
      config.headers = config.headers || {};
      
      // Set the auth token
      config.headers['x-auth-token'] = token;
      
      console.log('Adding auth token to request:', config.url);
    } else {
      console.warn('No auth token found for request:', config.url);
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response && error.response.status === 401) {
      console.error('Authentication error:', error.response.data);
      // Clear token if it's invalid
      if (error.response.data.msg === 'Token is not valid') {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const authService = {
  // Register a new user
  register: async (userData) => {
    try {
      console.log('Sending registration request with data:', userData);
      console.log('Current auth token:', localStorage.getItem('token'));
      
      // Make sure axios is using the latest token
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        }
      };
      
      const response = await axios.post(`${API_URL}/register`, userData, config);
      console.log('Registration successful:', response.data);
      return response.data;
    } catch (error) {
      console.error('Registration error:', error.response?.data || error.message);
      throw error;
    }
  },

  // Login user
  login: async (email, password) => {
    try {
      console.log('Sending login request to:', `${API_URL}/login`);
      const response = await axios.post(`${API_URL}/login`, { email, password });
      console.log('Login response received:', response.data);
      
      if (!response.data.token) {
        console.error('No token in response data:', response.data);
      }
      
      return response.data;
    } catch (error) {
      console.error('Login request failed:', error.response ? {
        status: error.response.status,
        data: error.response.data
      } : error.message);
      throw error;
    }
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await axios.get(`${API_URL}/me`);
    return response.data;
  }
};

export default authService;
